import React from 'react';

import { CircleOnDemandPageSection } from './CircleOnDemandPageSection';

export const CircleOnDemandRow = ({
    children,
    header,
    cta,
    to,
}: {
    header: string;
    cta?: string;
    to?: string;
    children: React.ReactNode;
}) => {
    return (
        <CircleOnDemandPageSection header={header} cta={cta} to={to}>
            {children}
        </CircleOnDemandPageSection>
    );
};
